// extracted by mini-css-extract-plugin
export default {"spin":"spin_spin__GQCSa"};